import { ds } from "js/core/models/dataService";

export const LinkType = {
    PUBLIC: "public",
    INVITE: "invite",
    EMBED: "embed",
    SOCIAL: "social",
    MEETING: "meeting"
};

export default class linkDS {
    static createPublicLink(presentation) {
        return presentation.links.createLink({
            name: "Public Link",
            type: LinkType.PUBLIC
        });
    }

    static createEmbedLink(presentation) {
        return presentation.links.createLink({
            name: "Embed Link",
            type: LinkType.EMBED
        });
    }

    static createInviteLink(presentation, email, customMessage) {
        return presentation.links.createLink({
            name: "Invite",
            email,
            customMessage,
            type: LinkType.INVITE
        });
    }

    static createSocialLink(presentation, socialNetwork) {
        return presentation.links.createLink({
            name: socialNetwork,
            type: LinkType.SOCIAL
        });
    }

    static createMeetingLink(presentation) {
        let meetingId = new Date().getTime().toString().substr(4);
        let hostPIN = Math.round(Math.random() * 899) + 100;
        // TODO: check if meeting id conflicts

        return presentation.links.createLink({
            name: "My meeting",
            type: LinkType.MEETING,
            meetingId,
            hostPIN,
            hasAudio: false
        });
    }

    static updateLink(link, options) {
        return link.update(options);
    }

    static saveLink(presentation, link) {
        return presentation.links.addLink(link);
    }

    static deleteLink(presentation, id) {
        return presentation.links.deleteLink(id);
    }

    static getLinkById(presentation, id) {
        return presentation.links.get(id);
    }

    static getPresentation() {
        return ds.selection.presentation;
    }
}
